import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import * as rulActions from 'home/Machines/MachineDetails/Health/actions/rul.actions';
import * as machineChartsActions from '../actions/machineCharts.actions';
import { getVisible as getAnnotationsVisible } from '../../../../Annotations/selectors/annotations.selectors';

export const tagChartPropTypes = {
  data: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.arrayOf(PropTypes.array)
  ]),
  tagId: PropTypes.number.isRequired,
  machineChartsActions: PropTypes.object.isRequired,
  displayOutliers: PropTypes.bool,
  editRULSettings: PropTypes.bool,
  rulFdp: PropTypes.string,
  rulStartTime: PropTypes.string,
  showOverlay: PropTypes.bool,
  isCepstrum: PropTypes.bool,
  selectedPoints: PropTypes.array,
  retryOverlayTrace: PropTypes.func,
  colors: PropTypes.arrayOf(PropTypes.string),
  activeData: PropTypes.arrayOf(PropTypes.bool),
  updateSelectedPoints: PropTypes.func,
  multipleSpeedMarkers: PropTypes.arrayOf(PropTypes.shape({
    index: PropTypes.number,
    speed: PropTypes.number,
    timestamp: PropTypes.string
  })),
  config: PropTypes.object,
  shaftSpeed: PropTypes.number,
  shaftSpeedUnit: PropTypes.string
};

export const tagChartDefaultProps = {
  data: undefined,
  displayOutliers: true,
  editRULSettings: false,
  rulFdp: null,
  rulStartTime: null,
  showOverlay: false,
  isCepstrum: false,
  selectedPoints: [],
  retryOverlayTrace: null,
  colors: ['#91B846'],
  activeData: [true],
  updateSelectedPoints: null,
  multipleSpeedMarkers: [],
  config: {},
  shaftSpeed: null,
  shaftSpeedUnit: null
};

const mapDispatchToProps = dispatch => ({
  machineChartsActions: bindActionCreators(machineChartsActions, dispatch),
  rulActions: bindActionCreators(rulActions, dispatch)
});

const mapStateToProps = state => ({
  componentId: state.breadcrumb.component.id,
  machineId: state.breadcrumb.machine.id,
  siteId: state.breadcrumb.site.id,
  user: state.user.user,
  currentAccount: state.currentAccount,
  annotationsVisible: getAnnotationsVisible(state)
});

export const withTagChartRedux = Component =>
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Component));
